import { create } from 'zustand'

export type ObjectiveFilter = 'all' | 'long' | 'short'
export type TfFilter = 'all' | '1h' | '4h' | '12h' | '1D' | '1W' | '1M'
export type SortKey = 'date' | 'relevance' | 'symbol'
export type EntryZoneFilter = 'all' | 'inside' | 'outside'
export type InOutFilter = 'all' | 'in'

export type OportunidadesFilters = {
  objective: ObjectiveFilter
  // Agora suporta múltiplas seleções; manter 'all' como sentinel
  timeframes: TfFilter[]
  minPercent: number // 0..100
  nearBreakOnly: boolean
  uiWarningOnly: boolean
  search: string
  sort: SortKey
  entryZone: EntryZoneFilter
  inOutMode: InOutFilter
}

type Store = OportunidadesFilters & {
  setObjective: (o: ObjectiveFilter) => void
  // Mantemos API rica para multi-seleção
  setTimeframes: (t: TfFilter[]) => void
  toggleTimeframe: (t: TfFilter) => void
  // Back-compat (não usar em novos pontos): define seleção única
  setTimeframe: (t: TfFilter) => void
  setMinPercent: (v: number) => void
  setNearBreakOnly: (v: boolean) => void
  setUiWarningOnly: (v: boolean) => void
  setSearch: (s: string) => void
  setSort: (s: SortKey) => void
  setEntryZone: (v: EntryZoneFilter) => void
  setInOutMode: (v: InOutFilter) => void
  reset: () => void
}

const initial: OportunidadesFilters = {
  objective: 'all',
  timeframes: ['all'],
  minPercent: 0,
  nearBreakOnly: false,
  uiWarningOnly: false,
  search: '',
  // Padrão: ordenar por data (mais recentes primeiro)
  sort: 'date',
  entryZone: 'all',
  inOutMode: 'all',
}

export const useOportunidadesFiltersStore = create<Store>((set, get) => ({
  ...initial,
  setObjective: (objective) => set({ objective }),
  setTimeframes: (timeframes) => set({ timeframes: timeframes.length ? timeframes : ['all'] }),
  toggleTimeframe: (t) => {
    const cur = get().timeframes || []
    // Se clicar em 'all', zera e deixa apenas 'all'
    if (t === 'all') {
      set({ timeframes: ['all'] })
      return
    }
    const hasAll = cur.includes('all')
    const base = hasAll ? [] : cur
    const exists = base.includes(t)
    const next = exists ? base.filter((x) => x !== t) : [...base, t]
    set({ timeframes: next.length ? next : ['all'] })
  },
  setTimeframe: (t) => set({ timeframes: [t] }),
  setMinPercent: (minPercent) => set({ minPercent }),
  setNearBreakOnly: (nearBreakOnly) => set({ nearBreakOnly }),
  setUiWarningOnly: (uiWarningOnly) => set({ uiWarningOnly }),
  setSearch: (search) => set({ search }),
  setSort: (sort) => set({ sort }),
  setEntryZone: (entryZone) => set({ entryZone }),
  setInOutMode: (inOutMode) => set({ inOutMode }),
  reset: () => set({ ...initial }),
}))
